import type { ResourcesConfig } from "aws-amplify";
import { env } from "./env.js";

/**
 * Amplify v6 config for the existing CDK-provisioned Cognito user pool.
 *
 * The v6 shape nests under `Auth.Cognito` (v5 was flat under `Auth`).
 * `loginWith.email: true` matches the user pool's `signInAliases.email`.
 * MFA is enforced by the user pool itself (`Mfa.REQUIRED`, TOTP-only) —
 * Amplify discovers this at sign-in time via Cognito's nextStep response,
 * so no client-side MFA opt-in is needed.
 *
 * No `signUpVerificationMethod` override needed — Cognito sends the
 * 6-digit code by email automatically because `autoVerify.email = true`.
 *
 * No callback/logout URLs because the primary UI uses SRP auth (no
 * redirects). The Hosted UI fallback (Phase 17 admin recovery) will add
 * those if/when needed.
 */
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.cognitoUserPoolId,
      userPoolClientId: env.cognitoUserPoolClientId,
      loginWith: { email: true },
      signUpVerificationMethod: "code",
      userAttributes: { email: { required: true } },
    },
  },
};
